export default "/images/icCheck.svg?70229c43a176dcb5a081523143ec7efc";